<script setup>
import { api } from '/app/plugins/services';
import { reactive, provide, watch } from 'vue';
import { usePlatform } from '/app/composables/platform';
import { useAuth } from '/app/composables/auth';
import { USER_BAN_KEY } from '/app/composables/moderation';

const { contextPlatform } = usePlatform();
const { auth } = useAuth();

const userBan = reactive({
	isBanned: false,
	untilDate: null,
	loading: false,
	error: null,
});

const fetchUserBanStatus = async () => {
	if (!auth.authenticated || !contextPlatform.value?.id || !auth.user?.id) {
		userBan.isBanned = false;
		userBan.untilDate = null;
		return;
	}

	userBan.loading = true;
	userBan.error = null;

	try {
		const { data: response } = await api.moderation.moderationUsers({
			platform_id: contextPlatform.value.id,
			status: 'active',
			page: 0,
			size: 20,
			user_id: auth.user.id,
		});

		const banRecord = (response.data || []).find((item) => item.moderation_type === 'ban');

		if (banRecord) {
			userBan.isBanned = true;
			userBan.untilDate = banRecord.until ? new Date(banRecord.until) : null;
		} else {
			userBan.isBanned = false;
			userBan.untilDate = null;
		}
	} catch (e) {
		userBan.error = e;
		userBan.isBanned = false;
		userBan.untilDate = null;
	} finally {
		userBan.loading = false;
	}
};

provide(USER_BAN_KEY, userBan);

watch(
	[() => contextPlatform.value?.id, () => auth.authenticated],
	() => {
		fetchUserBanStatus();
	},
	{ immediate: true }
);
</script>

<template>
	<slot />
</template>
